import { mutations } from "@/store/common/types.js";
import Vue from "vue";
import { mapActions, mapMutations } from "vuex";


Vue.mixin({
  data() {
    return {
      // get shopInfo() {
      //   if (process.env.NODE_ENV == "development") {
      //     return {
      //       ...window.__gem_shopInfo,
      //       shopifyDomain: process.env.VUE_APP_SHOP_SHOPIFY_DOMAIN
      //     };
      //   }
    };
  },
  computed: {
    publicPath() {
      return "";
      // return process.env.VUE_APP_S3_URL || "";
    }
  },
  methods: {
    ...mapActions("common", {
      gSnackbarCommit: "gSnackbarCommit",
      gLoadingCommit: "gLoadingCommit"
    }),
    ...mapMutations("common", {
      gDialogCommit: mutations.COMMON_OPEN_GDIALOG
    }),
  }
});

Vue.prototype.$forceCompute= function(computedName, forceUpdate /* default: true */) {
	if (this._computedWatchers[computedName]) {
		this._computedWatchers[computedName].run();
		if (forceUpdate || typeof forceUpdate == 'undefined') this.$forceUpdate()
	}
}

Vue.prototype.$chatbox = {
  show: () => {
    if (window.Intercom) window.Intercom("show");
    if (window.$crisp) window.$crisp.push(["do", "chat:open"])
  },
  hide: () => {
    if (window.Intercom) window.Intercom("hide");
    if (window.$crisp) window.$crisp.push(["do", "chat:close"])
  }
};

/**
 * Create a backup of body
 * @return {Object} object
 */
function __createBackup() {
  return {
    body: {
      position: ""
    }
  };
}

/**
 * Create a closer DOMElement
 * @param {String} id element id
 * @return {Node} $closerNode
 */
function __createCloser(id, { zIndex = "2147482900" }) {
  const $closer = document.createElement("div");
  $closer.id = id;
  $closer.style.position = "absolute";
  $closer.style.top = "0";
  $closer.style.right = "0";
  $closer.style.bottom = "0";
  $closer.style.left = "0";
  $closer.style.height = "calc(100vh - 60px)";
  $closer.style.zIndex = zIndex;

  return $closer;
}

const CrispGemController = (function() {
  const __backup = __createBackup();
  let __closerId = "__crispCloser";
  const clickToClose = () => {
    window.$crisp.push(["do", "chat:close"])
  };

  function onShow() {
    __backup.body.position = document.body.style.position;
    document.body.style.position = "relative";
    const $crisp = document.getElementsByClassName("crisp-client")[0];

    const $closer = __createCloser(__closerId, { zIndex: 0 })

    $crisp.parentNode.insertBefore($closer, $crisp);
    setTimeout(() => {
      $closer.addEventListener("click", clickToClose);
    }, 0)
  }

  function onHide() {
    document.body.style.position = __backup.body.position;
    const $closer = document.getElementById(__closerId);
    if ($closer) {
      $closer.removeEventListener("click", clickToClose);
      $closer.parentNode.removeChild($closer);
    }
  }
  return {
    onShow,
    onHide,
  }
})();

// const IntercomGemController = (function() {
//   const __backup = __createBackup();
//   let __closerId = "__intercomCloser";
//   const clickToClose = () => {
//     window.Intercom && window.Intercom("hide");
//   };

//   function onShow() {
//     __backup.body.position = document.body.style.position;
//       document.body.style.position = "relative";
//       const $intercom = document.getElementById("intercom-frame");
//       const $closer = __createCloser(__closerId)
//       $intercom.parentNode.insertBefore($closer, $intercom);
//       setTimeout(() => {
//         window.addEventListener("click", clickToClose);
//       }, 0)
//   }

//   function onHide() {
//     document.body.style.position = __backup.body.position;
//     const $closer = document.getElementById(__closerId);
//     if ($closer) {
//       $closer.parentNode.removeChild($closer);
//     }
//     window.removeEventListener("click", clickToClose);
//   }
//   return {
//     onShow,
//     onHide,
//   }
// })();

let interval = setInterval(() => {

  // Initiate closer for intercom
  if (window.Intercom) {
    const intercomUpdatedEvent = new CustomEvent("intercomUpdated", {});
    window.dispatchEvent(intercomUpdatedEvent);
    clearInterval(interval);
    const __backup = __createBackup();
    let __closerId = "__closer";
  
    const clickToClose = () => {
      window.Intercom && window.Intercom("hide");
    };
    window.Intercom("onShow", () => {
      __closerId = `__${Date.now()}`;
      __backup.body.position = document.body.style.position;
      document.body.style.position = "relative";
      const $closer = document.createElement("div");
      $closer.id = __closerId;
      const $intercom = document.getElementById("intercom-frame");
      $closer.style.position = "absolute";
      $closer.style.top = "0";
      $closer.style.right = "0";
      $closer.style.bottom = "0";
      $closer.style.left = "0";
      $closer.style.height = "calc(100vh - 60px)";
      $closer.style.zIndex = "2147482900";
      $intercom.parentNode.insertBefore($closer, $intercom);
      setTimeout(() => {
        window.addEventListener("click", clickToClose);
      }, 0)
    });
    window.Intercom("onHide", () => {
      document.body.style.position = __backup.body.position;
      const $closer = document.getElementById(__closerId);
      if ($closer) {
        $closer.parentNode.removeChild($closer);
      }
      window.removeEventListener("click", clickToClose);
    });
  }
  // if (window.Intercom) {
  //   clearInterval(interval);
  //   window.Intercom("onShow", IntercomGemController.onShow);
  //   window.Intercom("onHide", IntercomGemController.onHide);
  // }

  // // Initiate closer for crisp
  if (window.$crisp) {
    clearInterval(interval);
    window.$crisp.push(["on", "chat:opened", CrispGemController.onShow])
    window.$crisp.push(["on", "chat:closed", CrispGemController.onHide])
  }
}, 50);

let _interval = setInterval(() => {
  if (window.$crisp) {
    clearInterval(_interval);
    window.$crisp.push(["on", "session:loaded", () => {
      if (window.$crisp.is("chat:opened")) {
        CrispGemController.onShow();
      }
    }])
  }
}, 50)

Vue.prototype.$body = () => {
  return window.mainBody;
};

document.querySelectorAll('[gf-action="liveChat"]').forEach(el => {
  el.onclick = function() {
    if (window && window.Intercom) {
      window.Intercom("show");
    }
  };
});
